/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(document).ready(function ($) {
  let $result_spinner = null;

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        if ($result_spinner) {
          $result_spinner.removeClass('filter-reasonable-filter-result__spinner--active');
        }
      }
    });
  });

  $('.wp-block-query-pagination a').on('click', function (e) {
    const $result_block = $(this).closest('.wp-block-filter-reasonable-filter-result');

    $result_spinner = $result_block.find('.filter-reasonable-filter-result__spinner');

    $result_spinner.addClass('filter-reasonable-filter-result__spinner--active');

    const $wp_block_query = $(this).closest('.wp-block-query');
    const $wp_block_query_ul = $wp_block_query.find('ul');

    if (observer) {
      observer.observe($wp_block_query_ul[0], {
        childList: true
      });
    }
  })
});